import { isNotNullOrUndefined } from '../../../Util/TypeGuards';

export function ScrollToElement(scrollToElement: NodeListOf<Element>, scrollTo: ScrollLogicalPosition = 'start') {
	// We need to do this so that it executes after the the page has finished loading
	// otherwise it will execute before the page has loaded and not work as intended.
	setTimeout(() => {
		if (scrollToElement.length !== 0) {
			scrollToElement[0].scrollIntoView({
				behavior: 'smooth',
				block: scrollTo,
				inline: 'nearest',
			});
		}
	}, 0);
}

export function ScrollToItem(className: string, scrollTo: ScrollLogicalPosition = 'start') {
	// We need to do this so that it executes after the setErrors is completed
	// otherwise it will execute before the errors are set and not work as intended.
	setTimeout(() => {
		const myElement = document.querySelectorAll(`.${className}`);
		ScrollToElement(myElement, scrollTo);
	}, 0);
}

export function ScrollToTopOfElement(className: string) {
	// We need to do this so that it executes after the setErrors is completed
	// otherwise it will execute before the errors are set and not work as intended.
	setTimeout(() => {
		const myElement = document.querySelectorAll(`.${className}`);
		if (isNotNullOrUndefined(myElement[0])) {
			myElement[0].scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		}
	}, 0);
}

export function ScrollToClassNameWithParentScroll(
	className: string,
	parentSelector: string,
	scrollTo: ScrollLogicalPosition = 'start',
) {
	setTimeout(() => {
		const parentElement = document.querySelector(parentSelector);
		if (!parentElement) {
			console.warn(`Parent element with selector "${parentSelector}" not found.`);
			return;
		}

		const targetElements = document.querySelectorAll(`.${className}`);
		if (targetElements.length === 0) {
			console.warn(`Target elements with class name "${className}" not found.`);
			return;
		}

		const targetElement = targetElements[0];
		scrollParentAndChild(parentElement, targetElement, scrollTo);
	}, 0);
}

function scrollParentAndChild(parentElement: Element, targetElement: Element, scrollTo: ScrollLogicalPosition) {
	const parentRect = parentElement.getBoundingClientRect();
	const targetRect = targetElement.getBoundingClientRect();

	// Step 1: Scroll the parent to bring it fully into view
	if (parentRect.bottom > window.innerHeight) {
		const scrollAmount = Math.min(
			parentRect.bottom - window.innerHeight,
			parentElement.scrollHeight - parentElement.scrollTop,
		);
		parentElement.scrollTop += scrollAmount;
	}

	// Step 2: Scroll inside the child to locate the target element
	const scrollableChild = getScrollableParent(targetElement);
	if (scrollableChild) {
		const childRect = scrollableChild.getBoundingClientRect();
		const offsetTop = targetRect.top - childRect.top + scrollableChild.scrollTop;

		scrollableChild.scrollTo({
			top: offsetTop,
			behavior: 'smooth',
		});
	}
}

function getScrollableParent(element: Element): Element | null {
	let parent = element.parentElement;
	while (parent) {
		const style = window.getComputedStyle(parent);
		const { overflowY } = style;
		if (overflowY === 'auto' || overflowY === 'scroll') {
			return parent;
		}
		parent = parent.parentElement;
	}
	return null; // Default to no scrollable parent
}
